// =============================================================================
// TYPES
// =============================================================================

export interface MidsegmentElement {
  type: 'Midsegment';
  params: {
    /** Parent shape ID */
    of: string;
    /** Two edge names whose midpoints to connect, e.g. ['AB', 'BC'] for triangle, ['left', 'right'] for trapezoid */
    edges: [string, string];
  };
}
